<template>
  <div class="log">
    <!-- Filter -->
    <FilterFrame
      ref="filter"
      :filter-form="outputLogFilterStructure"
      class="filter-frame"
      @search="search"
      @clear="clearSearch()"
    />
    <div class="function">
      <el-button
        class="export-log"
        round
        @click="handleClickExport"
      >
        匯出
      </el-button>
    </div>
    <!-- Table -->
    <el-table
      :data="outputLogList"
      style="width: 100%"
    >
      <el-table-column
        label="#"
        type="index"
        width="50"
      />
      <el-table-column
        v-for="[key, value] of Object.entries(logStructure) "
        :key="key"
        :prop="key"
        :label="value"
      >
        <template slot-scope="scope">
          <div class="regular">
            <pre>{{ scope.row[key] || '-' }}</pre>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <TableLoading :is-loading="isLoading" />
  </div>
</template>

<script>
import TableLoading from '@/components/TableLoading'
import FilterFrame from '@/components/FilterFrame'
import { logStructure, logFilterStructure, TagStatus, TagLevelZh } from '../models'
import { todayISOString, lastMonthISOString, timeFormat, processFilterOptions } from '../utils'
export default {
  components: {
    FilterFrame,
    TableLoading
  },
  props: {
    assetCategoryDataOptions: Array
  },
  data () {
    const maxCount = 10
    const inputLogList = []
    const defaultReq = {
      TagLevelList: [1, 2, 3, 4],
      'CreateInterval.StartAt': lastMonthISOString,
      'CreateInterval.EndAt': todayISOString,
      MaxCount: maxCount
    }
    const req = defaultReq
    const isLoading = true
    const isNoMoreList = false
    const outputLogFilterStructure = logFilterStructure
    return {
      logStructure,
      outputLogFilterStructure,
      inputLogList,
      defaultReq,
      req,
      isLoading,
      isNoMoreList,
      maxCount
    }
  },
  computed: {
    outputLogList () {
      return this.inputLogList.map(el => {
        const tempEl = { ...el }
        tempEl.WarningTime = timeFormat(tempEl.WarningTime, true)
        tempEl.Status = TagStatus[tempEl.Status + 1]
        tempEl.TagLevel = TagLevelZh[tempEl.TagLevel]
        return tempEl
      })
    }
  },
  watch: {
    assetCategoryDataOptions (nV, oV) {
      const obj = this.outputLogFilterStructure.find(el => el.name === 'AssetCategoryId')
      obj.options = nV
      obj.isDisable = false
    }
  },
  mounted () {
    // 載入更多
    this.$nextTick(() => {
      window.addEventListener('scroll', this.handleScroll)
    })
    // 初始化（已移至 BA-alertView 呼叫）
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    async initLogList () {
      try {
        // 清空列表且呈現 loading 畫面
        this.inputLogList = []
        this.isLoading = true
        const res = await apiBaAlert.getLog(this.req)
        await this.$sleep(1000, res.duration)
        this.inputLogList = res.data
        this.isLoading = false
        this.isNoMoreList = false
      } catch (error) {
        console.log(error)
      }
    },
    handleScroll (e) {
      this.$handleScroll(this.getMoreLogList)
    },
    async getMoreLogList () {
      if (this.$route.name === 'baLog' && !this.isLoading && !this.isNoMoreList && this.outputLogList.length > 0) {
        this.isLoading = true
        const req = {
          ...this.req,
          MaxId: this.outputLogList[this.outputLogList.length - 1].LogId
        }
        try {
          const res = await apiBaAlert.getLog(req)
          // 至少也載個一秒鐘啦～～～
          await this.$sleep(1000, res.duration)
          if (res.data.length < this.maxCount) {
            this.isNoMoreList = true
          }
          this.inputLogList = [
            ...this.inputLogList,
            ...res.data
          ]
          return true
        } catch (error) {
          console.log(error)
          await this.$sleep()
          return false
        } finally {
          this.isLoading = false
        }
      }
    },
    search (filterOptions) {
      this.req = processFilterOptions(filterOptions, this.defaultReq)
      this.initLogList()
    },
    async handleClickExport () {
      try {
        const req = { ...this.req }
        delete req.MaxCount
        delete req.MaxId
        const res = await apiBaAlert.getLogExport(req)
        const today = dayjs().format('YYYYMMDD')
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `社區告警歷史紀錄_${today}.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.log(error)
      }
    },
    clearSearch () {
      this.req = this.defaultReq
      this.initLogList()
    },
    handleClickTagDetail (row) {
      if (row.Number > 0) {
        this.$emit('handleClickTagDetail', row)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.function {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.log {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 25px;
  .highlight {
    color: $dangerColor;
  }
  .clickable {
    color: $mainColorDark;
    text-decoration: underline;
    cursor: pointer;
  }
  ::v-deep .el-table {
    @include basicTable(true);
  }
}
</style>
